import type { Country } from '@kitopi-com/customer-auth';
import { sites } from 'context/sites';

export const getSiteCountry = (siteName: string | undefined): Country | undefined =>
  siteName ? sites.find(({ name }) => name === siteName)?.countryCode : undefined;
